// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"000605d6","453":"71cf7ae2","455":"33f818fc"}[chunkId] + ".chunk.js";
};